import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import DatePickerInput from "../Datepicker";
import Search from "../Search";
import ReportFilter from "./ReportFilter";
const downloadIcon = require("../../assets/images/download-icon.png");

interface Props {
  reportDate: Date;
  today: Date;
  onFilterSelect: any;
  selectedFilter: number;
  filterEntities: any;
  onClearFilter: any;
  agentList: any;
  onAgentSelect: any;
  onSetReportDate: any;
  searchQuery: string;
  onSearch: any;
  onSaveFilter: any;
  onDownload:any,
  agent:string
}

const ReportTabHeader = ({
  reportDate,
  today,
  onFilterSelect,
  selectedFilter,
  filterEntities,
  onClearFilter,
  agentList,
  onAgentSelect,
  onSetReportDate,
  searchQuery,
  onSearch,
  onSaveFilter,
  onDownload,
  agent
}: Props) => {
  return (
    <StyledReportTabHeader>
      <FieldContainer>
        <DatePickerInput
          //@ts-ignore
          // outlined={false}
          width="15rem"
          value={reportDate}
          maxDate={today}
          onChange={(e) => {
            onSetReportDate(e);
            //   setFromDate(e);
            //   setToDate(null);
          }}
        />
        <ReportFilter
          onFilterSelect={onFilterSelect}
          width="15rem"
          onChange={() => console.log("")}
          value={
            filterEntities.filter(
              (fl: any, index: any) => index === selectedFilter
            )[0].label
          }
          filterEntities={filterEntities}
          selectedFilter={selectedFilter}
          onClearFilter={onClearFilter}
          agentList={agentList}
          onAgentSelect={onAgentSelect}
          onSaveFilter={onSaveFilter}
          agent={agent}
        />
      </FieldContainer>
      <ActionContainer>
        <Search
          placeholder="Search for Ticket ID"
          onChange={onSearch}
          value={searchQuery}
        />
        <Button
          label="Download"
          variant="filled"
          color={Colors.solidRed}
          size="medium"
          isRounded={true}
          onClick={onDownload}
          endIcon={downloadIcon}
          width="10rem"
        />
      </ActionContainer>
    </StyledReportTabHeader>
  );
};

const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
  }
`;
const ActionContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  padding-top: 0.5rem;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
  padding-top: 2rem;

  }
`;
const StyledReportTabHeader = styled.div`
  margin: 1rem 0;
  padding:1rem;
  display: flex;
  align-content: center;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
  }
`;

export default ReportTabHeader;
